import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import FormComprovantes from './FormComprovantes';

function DialogComprovantes({ open, onClose, ...props }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle
                sx={{
                    bgcolor: '#f5f5f5',
                    color: '#222',
                    fontWeight: 700,
                    borderBottom: '1px solid #ddd',
                }}
            >
                Comprovantes do Movimento
            </DialogTitle>

            <DialogContent dividers>
                <FormComprovantes onClose={onClose} {...props} />
            </DialogContent>
        </Dialog>
    );
}

export default DialogComprovantes;
